export const state = {
    loading: false
};


export const mutations = {
    START_LOADING(state) {
        state.loading = true;
    },
    END_LOADING(state) {
        state.loading = false;
    }
};

export const actions = {
    startLoading({ commit }) {
        commit('START_LOADING');
    },
    endLoading({ commit }) {
        commit('END_LOADING');
    },
}